import { LocalStorage } from "@/common/storage.ts";
import { MANAGER_PATH } from "@/constant/url-path.ts";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const MainRoute = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const accessToken = LocalStorage.getAccessToken();
    if (accessToken) {
      navigate(MANAGER_PATH.LICENSE_REGISTRATION.LIST, { replace: true });
    } else {
      navigate(MANAGER_PATH.AUTH.SIGN_IN, { replace: true });
    }
  }, [navigate]);
  return <></>;
};

export default MainRoute;
